import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const individualSchema = Yup.object().shape({
  thumbnail: Yup.string().nullable(),
  biography: Yup.string()
});

export type IndividualData = Yup.InferType<typeof individualSchema>;

export const individualResolver = yupResolver(individualSchema);
